import api from './api';

export const agentService = {
  /**
   * Get execution status
   */
  getExecutionStatus: async (executionId) => {
    const response = await api.get(`/agent/executions/${executionId}`);
    return response.data.data;
  },

  /**
   * Get all active executions for user
   */
  getActiveExecutions: async () => {
    const response = await api.get('/agent/executions', {
      params: { status: 'active' }
    });
    return response.data.data;
  },

  /**
   * Approve action
   */
  approveAction: async (actionId) => {
    const response = await api.post(`/agent/actions/${actionId}/approve`);
    return response.data;
  },

  /**
   * Reject action
   */
  rejectAction: async (actionId, reason) => {
    const response = await api.post(`/agent/actions/${actionId}/reject`, {
      reason
    });
    return response.data;
  },

  /**
   * Provide missing information
   */
  provideMissingInfo: async (actionId, answers) => {
    const response = await api.post(`/agent/actions/${actionId}/provide-info`, {
      answers
    });
    return response.data;
  },

  /**
   * Cancel execution
   */
  cancelExecution: async (executionId) => {
    const response = await api.post(`/agent/executions/${executionId}/cancel`);
    return response.data;
  },

  /**
   * Get execution log
   */
  getExecutionLog: async (executionId) => {
    const response = await api.get(`/agent/executions/${executionId}/log`);
    return response.data.data;
  },

  /**
   * Get execution screenshots
   */
  getExecutionScreenshots: async (executionId) => {
    const response = await api.get(`/agent/executions/${executionId}/screenshots`);
    return response.data.data;
  }
};
